import React, { useEffect, useState } from 'react';
import { getReconciliationStats } from '../../../../API/reconciliationApi';

/**
 * Activity-level header counters: Accounts/Library submitted vs pending,
 * plus "ready to send admit card" count.
 *
 * Re-fetches when `refreshKey` changes.
 */
export default function ReconciliationStatsBar({ activityId, refreshKey = 0 }) {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!activityId) return;
    let cancelled = false;
    setLoading(true);
    getReconciliationStats(activityId)
      .then((res) => {
        if (cancelled) return;
        if (res?.error) return;
        setStats(res);
      })
      .finally(() => !cancelled && setLoading(false));
    return () => {
      cancelled = true;
    };
  }, [activityId, refreshKey]);

  if (!stats || (stats.required_report_types || []).length === 0) return null;

  const required = new Set(stats.required_report_types || []);
  const total = stats.total_students || 0;

  const row = (label, submitted, pending) => (
    <div key={label} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <span style={{ fontWeight: 600, fontSize: 12, color: '#5B3CC0', minWidth: 60 }}>{label}</span>
      <span style={{ fontSize: 12, color: '#16a34a', fontWeight: 600 }}>{submitted} submitted</span>
      <span style={{ fontSize: 12, color: '#d4380d', fontWeight: 600 }}>{pending} pending</span>
    </div>
  );

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 6,
        opacity: loading ? 0.7 : 1,
        background: '#fff',
        borderLeft: '4px solid #7F56DA',
        borderRadius: '4px',
        padding: '6px 14px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        minWidth: 0,
        height: '100%',
        boxSizing: 'border-box',
      }}
    >
      {required.has('accounts') &&
        row('Accounts', stats.accounts?.submitted ?? 0, stats.accounts?.pending ?? 0)}
      {required.has('library') &&
        row('Library', stats.library?.submitted ?? 0, stats.library?.pending ?? 0)}
      <div style={{ fontSize: 12, fontWeight: 600, color: '#0958d9' }}
        title="Students whose required reports are all submitted">
        Ready: {stats.ready_to_send_admit_card ?? 0} / {total}
      </div>
    </div>
  );
}
